import React from "react";
import { Route, Routes } from "react-router-dom";
import Orders from "./pages/Orders";
import Products from "./pages/Products";
import DetailProduct from "./pages/DetailProduct";
import AddProduct from "./pages/AddProduct";
import Reports from "./pages/Reports";
import AddCategory from "./pages/AddCategory";
import Category from "./pages/Category";
import Users from "./pages/Users";
import AddCoupon from "./pages/AddCoupon";
import AddUser from "./pages/AddUser";
import Coupons from "./pages/Coupons";
import Login from "./pages/Login";
import Contact from "./pages/Contact";
import { Home } from "./layout/Home";
import { Layout } from "./layout";
import { ProtectedRoute } from "./layout/ProjectedRoute";

import "./App.css";

function App() {
  return (
    <>
      <Routes>
        <Route path="/dashboard" element={<Layout />}>
          <Route index element={<Reports />} />
          <Route path="orders" exact element={<Orders />} />

          <Route
            path="users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="adduser"
            exact
            element={
              <ProtectedRoute>
                <AddUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="adduser/:item"
            exact
            element={
              <ProtectedRoute>
                <AddUser />
              </ProtectedRoute>
            }
          />

          <Route
            path="category"
            exact
            element={
              <ProtectedRoute>
                <Category />
              </ProtectedRoute>
            }
          />
          <Route
            path="addcategory"
            exact
            element={
              <ProtectedRoute>
                <AddCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="addcategory/:categoryId"
            element={
              <ProtectedRoute>
                <AddCategory />
              </ProtectedRoute>
            }
          />

          <Route
            path="products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route
            path="product/:productId"
            element={
              <ProtectedRoute>
                <DetailProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="addproduct"
            exact
            element={
              <ProtectedRoute>
                <AddProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="addproduct/:productId"
            exact
            element={
              <ProtectedRoute>
                <AddProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="coupons"
            exact
            element={
              <ProtectedRoute>
                <Coupons />
              </ProtectedRoute>
            }
          />
          <Route
            path="addcoupon"
            exact
            element={
              <ProtectedRoute>
                <AddCoupon />
              </ProtectedRoute>
            }
          />
          <Route
            path="addcoupon/:item"
            exact
            element={
              <ProtectedRoute>
                <AddCoupon />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path="contact" exact element={<Contact />} />
        <Route path="" element={<Home />}>
          <Route path="/" exact element={<Reports />} />
          <Route path="/login" exact element={<Login />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
